// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z2HJt","colMin":"styles_colMin__1Kujy"};